import * as CardStatusRoles from 'const/CardStatusRoles'

export const getStatusIconName = (roleId) => {
  switch (roleId) {
    case CardStatusRoles.NONE:
      return 'kanbo-16-player-empty'
    case CardStatusRoles.NOT_STARTED:
      return 'kanbo-16-player-stop'
    case CardStatusRoles.IN_PROGRESS:
      return 'kanbo-16-player-play-2'
    case CardStatusRoles.COMPLETED:
      return 'kanbo-16-completed-inactive'
    default:
      return ''
  }
}

export const getStatusFormattedMessageId = (roleId) => {
  switch (roleId) {
    case CardStatusRoles.NONE:
      return 'CARD_STATUS_ROLE_NONE'
    case CardStatusRoles.NOT_STARTED:
      return 'CARD_STATUS_ROLE_NOT_STARTED'
    case CardStatusRoles.IN_PROGRESS:
      return 'CARD_STATUS_ROLE_IN_PROGRESS'
    case CardStatusRoles.COMPLETED:
      return 'CARD_STATUS_ROLE_COMPLETED'
    default:
      return ''
  }
}